import {Card, Stack, Typography} from '@mui/material';
import React from 'react';

import emptyTokenImg from 'presentation/assets/images/empty-token.svg';
import {useMediaQueries} from 'presentation/pages';
import {translations} from 'presentation/translations-new';
import {ImageContainer, StyledBox} from './styles';

const {emptyToken} = translations['pt-br'].privateFlow.token;

export function EmptyTokenState() {
	const {isMobile} = useMediaQueries();
	return (
		<Card elevation={0}>
			<StyledBox>
				<Stack gap={2} maxWidth={isMobile ? '100%' : 394} ml="auto">
					<Typography variant="h6">{emptyToken.title}</Typography>
					<Typography color="text.secondary">{emptyToken.description}</Typography>
				</Stack>
				<ImageContainer>
					<img src={emptyTokenImg} alt="Imagem de tempo expirado" />
				</ImageContainer>
			</StyledBox>
		</Card>
	);
}
